import { datadogRum } from '@datadog/browser-rum';

export const trackAction = (action: string, opts?: Record<string, unknown>): void => {
  datadogRum.addAction(action, opts);
};
